import { importsSalesforceSummaryGetSlice } from './get';

export const { requestGetImportsSalesforceSummary, resetGetImportsSalesforceSummary } =
	importsSalesforceSummaryGetSlice.asyncActionCreators;
